var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed100",
    d: "M9 29.6c-.6 0 5.2-3.1 10-7 6.5-5.4 20.2-13.6 24.2-15 .4-.1-.8.7-1 1-4.3 5-.9 14.7 4.5 19.5 1.6 1.2 1.5 1.3 4.5 1.4v.3zm-.3.5s-.4.3-.4.5.4.6.4.6l41.6.4.7-.5-1-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.9 9-.3 1.1.8-.6.9.6-.3-1 .8-.6h-1l-.4-1-.3 1h-1zm6.5 4.9.7-.6h-.9l-.2-.8-.3.8h-.9l.7.6-.3.8.8-.5.7.5zm-12 1L3 14l-.3 1H1.6l.8.7-.3 1L3 16l.8.6-.3-1 .9-.6zm6.4 10.2L9.4 24l-.3 1H7.8l1 .8-.4 1.2 1-.8 1 .8-.3-1.2 1-.7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/tk.60e6d84ae83ba8774d81baeddbfc1f98.svg";
export { ForwardRef as ReactComponent };